module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "sigil_not_in_toc"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagev",
      "title": "v"
    }
  })]), _vm._v(" "), _c('h6', {
    staticClass: "sigil_not_in_toc"
  }, [_vm._v("FROM STEWART KELLY:")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("In honor of Shirley Lachs, for her kindness, generosity, and encouragement")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('br')]), _vm._v(" "), _c('h6', {
    staticClass: "sigil_not_in_toc"
  }, [_vm._v("FROM JAMES DEW:")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("To TD and the Dew Crew—my greatest joys this side of heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagevi",
      "title": "vi"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d3f72b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/03_dedication.vue
// module id = 60
// module chunks = 0